import { render } from "./IconWave.vue?vue&type=template&id=6477cd0c"
import script from "./IconWave.vue?vue&type=script&lang=js"
export * from "./IconWave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__